import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DatetimeChangeEventDetail, IonDatetimeCustomEvent } from '@ionic/core';
import { isWeekend, startOfTomorrow } from 'date-fns';
import { AppCommonModule } from 'src/app/common.module';
import { MainDialogComponent } from 'src/app/components/main-dialog/main-dialog.component';
import { getDateWithTimezone } from 'src/app/utility/time';

@Component({
  selector: 'app-demo-dialog',
  templateUrl: './demo.dialog.html',
  styleUrls: ['./demo.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
    MainDialogComponent,
  ],
})
export class DemoDialogComponent implements OnInit {
  private _modal = inject(ModalController);

  minDate = startOfTomorrow().toISOString();
  value: string;

  isWeekday = (dateString: string) => {
    const date = new Date(dateString);
    return !isWeekend(date);
  };

  willEnter = signal(false);

  ngOnInit(): void {
    const initialValue = startOfTomorrow();
    initialValue.setHours(10, 0, 0, 0);
    this.value = getDateWithTimezone(initialValue);
    this.willEnter.set(true);
  }

  onChange(event: IonDatetimeCustomEvent<DatetimeChangeEventDetail>) {
    const value = event.detail.value;
    this.value = value as string;
  }

  reserve() {
    const val = new Date(this.value);
    this._modal.dismiss(new Date(val));
  }

  dismiss() {
    this._modal.dismiss();
  }
}
